export default __webpack_public_path__ + "static/media/bell.4e3e485e.svg";